function collectionWithTabs() {
  const cwts = document.querySelectorAll('.collections-with-tabs');

  cwts.forEach(cwt => {
    if (!cwt || cwt.dataset.tabsInit === 'true') return;
    cwt.dataset.tabsInit = 'true';

    const cwtNavigationItems = cwt.querySelectorAll('.tabs-navigation-item');
    const cwtNavigationSelect = cwt.querySelector('.tabs-navigation-select');
    const cwtList = cwt.querySelectorAll('.product-grid');

    const activateTab = (item) => {
      const tagid = item.dataset.tab || item.value;
      cwtNavigationItems.forEach(element => element.classList.remove('active'));
      cwtList.forEach(element => element.classList.remove('active'));
      item.classList.add('active');

      const tabElement = cwt.querySelector(`[data-tab-id="${tagid}"]`);
      if (tabElement) {
        tabElement.classList.add('active');
      }
    };

    // Tab buttons work on all screen sizes (mobile uses the same buttons as desktop)
    cwtNavigationItems.forEach(item => {
      item.addEventListener('click', () => activateTab(item));
      item.addEventListener('keyup', (e) => {
        if (e.key === 'Enter' || e.key === ' ') activateTab(item);
      });
    });

    // Legacy dropdown fallback, only if still present in markup
    if (cwtNavigationSelect) {
      cwtNavigationSelect.addEventListener('change', () => activateTab(cwtNavigationSelect));
    }
  });
}

document.addEventListener('DOMContentLoaded', collectionWithTabs);
document.addEventListener('shopify:section:load', collectionWithTabs);
